import { RcClasses } from '../../../foundation';
export var RcDialogClasses = RcClasses([
    'paper',
    'root',
    'paperFullScreen',
    'paperWidthXs',
    'paperScrollBody',
    'paperFullScreen',
], 'RcDialog');
export var RcDialogMaxWidths = {
    xsmall: '272px',
    small: null,
    medium: null,
    large: null,
    fullScreen: null,
};
